import { render, staticRenderFns } from "./ArticleCompositionItem.vue?vue&type=template&id=7c3c6c9e&"
import script from "./ArticleCompositionItem.vue?vue&type=script&lang=js&"
export * from "./ArticleCompositionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports